'use strict';

var FormView = require('commons/views/Form');
var modal =    require('helpers/modal');

module.exports = FormView.extend({
    className: 'ibox m-b-lg',

    bindHandlers: function() {
        var r = FormView.prototype.bindHandlers.apply(this, arguments);

        this.on('saved', this.showSavedToast, this);

        return r;
    },

    unbindHandlers: function() {
        var r = FormView.prototype.bindHandlers.apply(this, arguments);

        this.off('saved', this.showSavedToast, this);

        return r;
    },

    showSavedToast: function() {
        var thing = this.options.thing || 'personal settings';

        modal.showAlertSuccess('Your ' + thing + ' have been saved');
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/PersonalSettingsPanel.js